/* Reserves the bar's row in the frame. The remote's own bar is position: fixed
   at the top of the viewport and 40px tall (UserManagementUI AdminBar.vue). */
.adminBar {
  flex: none;
  min-height: 40px;
}
